var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('test-plan-data-list',{attrs:{"category":"story","loading":_vm.loading,"table-data":_vm.tableData,"pagination":false},on:{"reload":_vm.getPlanList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }